import type { Customer } from '../../../@types/Customer.js';

export const marketplaceShareMap = {
  Group: 'c2c',
  Retailer: 'r2c',
} as const satisfies Partial<Record<Customer, string>>;

type MarketplaceRole = keyof typeof marketplaceShareMap;
export type MarketplaceShare = (typeof marketplaceShareMap)[MarketplaceRole];

/**
 * Converts a customer to a type of share.
 *
 * @param customer The customer to convert (Group or Retailer)
 * @returns The type of share (c2c or r2c)
 */
export function convertRoleToTypeOfShare(customer: Customer): MarketplaceShare | undefined {
  if (customer in marketplaceShareMap) {
    return marketplaceShareMap[customer as MarketplaceRole];
  }

  return undefined;
}
